export default {
    /**
     * @param color
     * @return {string}
     */
    contrastingColor(color) {
        return (this.luma(color) >= 165) ? '000' : 'fff';
    },

    /**
     * color can be a HEX string or an array of RGB values 0-255
     * @param color
     * @return {number}
     */
    luma(color) {
        let rgb = (typeof color === 'string') ? this.hexToRGBArray(color) : color;
        return (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]); // SMPTE C, Rec. 709 weightings
    },

    /**
     * @param color
     * @return {[]}
     */
    hexToRGBArray(color) {
        color = color.replace('#', '')
        if (color.length === 3)
            color = color.charAt(0) + color.charAt(0) + color.charAt(1) + color.charAt(1) + color.charAt(2) + color.charAt(2);
        else if (color.length !== 6)
            throw('Invalid hex color: ' + color);
        let rgb = [];
        for (let i = 0; i <= 2; i++)
            rgb[i] = parseInt(color.substr(i * 2, 2), 16);
        return rgb;
    },

    /**
     * @param color
     * @param scale
     * @return {string}
     */
    rgbToRgba(color, scale = 0.85) {
        let rgb = (typeof color === 'string') ? this.hexToRGBArray(color) : color;
        return `rgba(${rgb[0]},${rgb[1]},${rgb[2]}, ${scale}`;
    },

    /**
     * @param color
     * @param element
     */
    setDocumentAccentColor(color, element = null) {
        if (element === null) {
            element = document.documentElement
        }
        element.style.setProperty("--accent-color", color);
        element.style.setProperty("--darken-accent-color", this.rgbToRgba(color));
        element.style.setProperty("--text-color", '#' + this.contrastingColor(color));
    },

    /**
     * @param element
     */
    resetColors(element = null) {
        if (element === null) {
            element = document.documentElement
        }
        element.style.removeProperty('--accent-color');
        element.style.removeProperty('--darken-accent-color');
        element.style.removeProperty('--text-color');
    }
}
